export const PROFILE_MENU_ITEMS = {
    ACCOUNT_INFO: "Account Information",
    REPORT_BUGS: "Report an Issue",
    ABOUT_THIS: "About This Software",
    SECURITY: "Security",
};

export const profileEmailMessages = {
    SUCCESS: "Email updated successfully.",
    EMAIL_ALREADY_TAKEN: "Email already taken.",
    EMPTY_STRING: "Email cannot be empty.",
};

export const profileSettingsFields = {
    PROFILE_PICTURE: "Profile Picture",
    USERNAME: "Username",
};

export const securityTitles = {
    MFA: "Multi-Factor Authentication",
    CHANGE_PASSWORD: "Change Password",
};

export const securityMessages = {
    SUCCESS: "Password updated successfully. You will need to log in again.",
    WRONG_CURRENT_PASSWORD: "Current password is incorrect.",
    PASSWORDS_DONT_MATCH: "Passwords do not match.",
    EMPTY_PASSWORD: "New password cannot be empty.",
    EMPTY_CURRENT_PASSWORD: "Current password must be provided.",
    SAME_PASSWORD: "New password must be different from current password.",
    COMMON_PASSWORD: "New password cannot be a common word.",
    PERSONAL_INFO_PASSWORD: "New password cannot contain personal information.",
    SHORT_PASSWORD: "New password must be at least 8 characters long.",
    NOT_ENOUGH_CHARACTER_TYPE_PASSWORD:
        "New password does not meet character type requirements. Please hover on 'New Password' text box for further details.",
};

export const securityFields = {
    CURRENT_PASSWORD: "Current password",
    NEW_PASSWORD: "New password",
    PASSWORD_CONFIRMATION: "Password confirmation",
    PASSWORD_SUBMIT: "Change Password",
};

export const ABOUT_THIS_SOFTWARE_TEXT = {
    USER_MANUAL_DESCRIPTION:
        "Download the most recent version of the User Manual for this Software",
    USER_MANUAL_BTN: "Download",
    TRAINING_DESCRIPTION: "Access Unfold AI software training resources",
    TRAINING_BTN: "Start Training",
    TEMPLATE_DESCRIPTION: "Download fusion core templates",
    TEMPLATE_BTN_PDF: "Download template (.pdf)",
    TEMPLATE_BTN_DOCX: "Download template (.docx)",
    SOFTWARE_VERSION: "Software Version:",
    UDI: "UDI:",
    LAMBDA_ENDPOINT: "Lambda API Endpoint:",
    TASK_ENDPOINT: "Task API Endpoint:",
    PATENT_DESCRIPTION: "Patent Number:",
    PATENT_NUMBER: "US 12,711,620 B2",
};

export const SUBJECT_MENU_ITEMS = {
    DEFAULT: "Select",
    OPTION_1: "Software Issue",
    OPTION_2: "Feedback",
    OPTION_3: "Support Request",
};
